// noinspection DuplicatedCode

import { useState } from 'react';
import { useMutation } from 'react-query';
import PartnerProfileService from 'api/PartnerProfileService';

export default function UseItemInformation(props) {
  const { onSubmit } = props;
  const [medias, setMedias] = useState([]);
  const [detailsToSave, setDetailsToSave] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [itemInformation, setItemInformation] = useState(null);
  const [isShowItemMediaForm, setIShowItemMediaForm] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const mutationGetMedias = useMutation(
    (itemId) => PartnerProfileService.getContentBlock(itemId),
    {
      onSuccess: (response) => {
        setMedias([]);
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          const temp = [];
          response.data.data.map((d) => {
            if (d.value) {
              const { value } = d;
              value.id = d.id;
              temp.push(value);
            }
            return d;
          });
          setMedias(temp);
        }
      },
    }
  );
  const mutationDeleteBlockData = useMutation(
    (blockId) => PartnerProfileService.deleteBlockData(blockId),
    {
      onSuccess: () => {
        mutationGetMedias.mutate(itemInformation.id);
      },
    }
  );
  const getMaxDisplayOrder = (order) => {
    if (order.length > 0 || order > 0) {
      return Number(order);
    }

    if (medias.length === 0) {
      return 1;
    }
    return medias.length + 1;
  };
  const onItemParameterEditorSubmit = (details) => {
    setIsLoading(true);
    onSubmit(details);
  };
  const showMediaFormEditor = () => {
    setSelectedMedia({
      data: [
        {
          dataKey: 'item_media_',
          groupKey: 'item_',
          value: {
            id: '',
            displayOrder: '',
            title: '',
            description: '',
            mediaType: 'image',
            mediaPath: '',
            mediaPreviewPath: '',
            blockId: itemInformation.id,
          },
        },
      ],
    });
    setIShowItemMediaForm(true);
  };
  const onMediaParameterEditorCancel = () => {
    setIShowItemMediaForm(false);
  };
  const onMediaParameterEditorSubmit = (details) => {
    const { file, data, type, previewImage } = details;
    const savePreviewImage = (dataKey, files) =>
      PartnerProfileService.uploadFile({
        blockDataItemDataKey: dataKey,
        file: files,
        type: 'file_preview_upload',
      });
    const complete = () => {
      mutationGetMedias.mutate(itemInformation.id);
      onMediaParameterEditorCancel();
    };
    if (data.length > 0) {
      const { value } = data[0];
      value.displayOrder = getMaxDisplayOrder(value.displayOrder);
      if (value && value.id.length === 0) {
        PartnerProfileService.addBlockData(itemInformation.id, {
          dataKey: data.dataKey,
          groupKey: data.groupKey,
          value,
        }).then((response) => {
          if (response.data && response.data.dataKey) {
            savePreviewImage(response.data.dataKey, previewImage).then(() => {
              if (type === 'image' && file && file.length > 0) {
                PartnerProfileService.uploadFile({
                  blockDataItemDataKey: response.data.dataKey,
                  file,
                })
                  .then(() => {
                    complete();
                  })
                  .catch(() => complete());
              } else {
                complete();
              }
            });
          }
        });
      } else {
        PartnerProfileService.updateBlockData(
          value.id,
          JSON.stringify(value)
        ).then((response) => {
          if (response.data && response.data.dataKey) {
            savePreviewImage(response.data.dataKey, previewImage).then(() => {
              if (type === 'image' && file && file.length > 0) {
                PartnerProfileService.uploadFile({
                  blockDataItemDataKey: response.data.dataKey,
                  file,
                })
                  .then(() => {
                    complete();
                  })
                  .catch(() => complete());
              } else {
                complete();
              }
            });
          }
        });
      }
    }
  };
  const editMedia = (m) => {
    setSelectedMedia({
      data: [
        {
          dataKey: 'item_media_',
          groupKey: 'item_',
          value: m,
        },
      ],
    });
    setIShowItemMediaForm(true);
  };
  const deleteMedia = (id) => {
    mutationDeleteBlockData.mutate(id);
  };
  const mediaTypeText = (type) => {
    if (type === 'image') {
      return 'Image';
    }
    if (type === 'link') {
      return 'Link';
    }
    if (type === 'youtube') {
      return 'YouTube';
    }
    return '';
  };
  return {
    medias,
    setMedias,
    detailsToSave,
    setDetailsToSave,
    isLoading,
    setIsLoading,
    itemInformation,
    setItemInformation,
    isShowItemMediaForm,
    setIShowItemMediaForm,
    selectedMedia,
    setSelectedMedia,
    mutationGetMedias,
    mutationDeleteBlockData,
    getMaxDisplayOrder,
    onItemParameterEditorSubmit,
    showMediaFormEditor,
    onMediaParameterEditorCancel,
    onMediaParameterEditorSubmit,
    editMedia,
    deleteMedia,
    mediaTypeText,
  };
}
